import { error, money } from 'services/graphql/fragments/Fragments';
import {
  AnalyticsEventFragment,
  SystemBannerFragment,
} from 'services/graphql/fragments/HomeTilesContentFragment';
import { gql } from 'urql';

const fetchVaroAdvanceProducts = gql`
  query VaroAdvanceProducts($input: VaroAdvanceProductsInput) {
    varoAdvanceProducts(input: $input) {
      __typename
      ... on VaroAdvanceProductsQualified {
        hasEligibilityRestrictions
        isFirstTime
        hasActiveAdvanceAccount
        options {
          id
          feeTier
          amount {
            ...money
          }
          fee {
            ...money
          }
          title
          description
          qualificationMethod
        }
        repaymentDates {
          defaultDate
          dueDate
          exclusionReason
          exclusions
          max
          min
          valid
        }
        inlineAlert {
          ...SystemBannerFragment
        }
      }
      ... on VaroAdvanceProductsNotQualified {
        title
        reason
        qualificationContentList
        addtionalInfo {
          copy
        }
      }
      ... on VaroAdvanceProductsError {
        ...error
      }
    }
  }
  ${error}
  ${money}
  ${SystemBannerFragment}
  ${AnalyticsEventFragment}
`;

export default fetchVaroAdvanceProducts;
